/**
 * The credits usage BAND, keyed to the fraction of the cap USED: <50% green, 50–<85% orange,
 * ≥85% red. Shared 1:1 with the native apps (`creditsUsageLevel` in iOS `Components.swift` and
 * Android `CreditsUsage.kt`), thresholds and boundary equality included.
 *
 * It no longer colours anything. The credits meter is drawn in ink at EVERY level now — Figma
 * 15375-104792 (account) / 15375-104636 (drawer) — because the card's CTA took the brand green,
 * so the bar takes `progress="neutral"` and does not branch. What survives is the band itself,
 * which is still the one thing that says "this account is nearly out": the earn-credits offer
 * gates on `red` (lib/earn-credits-offer.ts), exactly as iOS's `OutOfCreditsEarnOffer` does.
 *
 * The `creditsProgress` mapping that used to turn this band into a Progress Bar level is gone
 * with the ladder — a helper returning the same level for every input would only have hidden the
 * fact that the bar stopped branching.
 */
export type CreditsUsageLevel = 'green' | 'orange' | 'red';

export function creditsUsageLevel(fraction: number): CreditsUsageLevel {
  if (fraction >= 0.85) return 'red';
  if (fraction >= 0.5) return 'orange';
  return 'green';
}
